// extracted by mini-css-extract-plugin
module.exports = {"title":"Checkbox_title__2wxMI"};